import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh.json'
import en from './en.json'

Vue.use(VueI18n)

const messages = { zh, en }

function defaultLocale() {
  const saved = localStorage.getItem('lang')
  if (saved) return saved
  const nav = navigator.language || navigator.userLanguage
  if (nav && nav.toLowerCase().startsWith('zh')) return 'zh'
  return 'en'
}

export default new VueI18n({
  locale: defaultLocale(),
  fallbackLocale: 'en',
  messages
})
